import Cookies from 'js-cookie'

export const TOKEN_KEY = 'company-token'

export const setToken = (token) => {
  // Cookies.set(TOKEN_KEY, token, {expires: 15})
  localStorage.setItem(TOKEN_KEY, token)
}

export const getToken = () => {
  // const token = Cookies.get(TOKEN_KEY)
  // if (token) return token
  // else return false
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) return token
  else return false
}
